<section class="hero">
  <div class="hero-container">
    <div class="hero-split">
      <div class="hero-left">
        <h1 class="fade-in-up">
          Transformez votre <span class="highlight">mission comptable</span> en conseil patrimonial
        </h1>
        <p class="fade-in-up delay-1">
          Wealthlane permet aux experts-comptables de générer automatiquement des <span class="highlight">bilans patrimoniaux professionnels</span> à partir de données comptables. Une nouvelle source de revenus en quelques clics.
        </p>
        <div class="hero-cta fade-in-up delay-2">
          <a  class="hero-btn-primary" [routerLink]="'/login'">Démarrer l'essai gratuit</a>
          <a  class="hero-btn-secondary" (click)="scrollTo('decouvrir')">Découvrir Wealthlane</a>
        </div>
      </div>
      <div class="hero-right fade-in-up delay-2">
        <div class="dashboard-preview">
          <div class="dashboard-header">
            <span class="dashboard-icon">⚡</span>
            <h3>Génération instantanée</h3>
          </div>
          <p class="dashboard-subtitle">De l'import comptable au rapport patrimonial complet</p>
          <div class="dashboard-stats">
            <div class="dashboard-stat">
              <div class="stat-value">&lt; 5min</div>
              <div class="stat-label">Génération</div>
            </div>
            <div class="dashboard-stat">
              <div class="stat-value">50+</div>
              <div class="stat-label">Solutions</div>
            </div>
            <div class="dashboard-stat">
              <div class="stat-value">100%</div>
              <div class="stat-label">Automatisé</div>
            </div>
            <div class="dashboard-stat">
              <div class="stat-value">2-8k€</div>
              <div class="stat-label">Par mission</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

